import React, { useState } from "react";
import { Link } from "react-router-dom";
// Icons import
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube, FaPaperPlane } from "react-icons/fa";

function ContactComp() {
    const [formData, setFormData] = useState({
        firstName: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });

    const [status, setStatus] = useState({ loading: false, type: '', msg: '' });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ loading: true, type: '', msg: '' });

        try {
            // Updated Logic for Node.js Backend:
            // Hum localhost:5000 par request bhej rahe hain jahan Node server chal raha hai
            const response = await fetch('http://localhost:5000/send-email', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (response.ok && result.status === 'success') {
                setStatus({ loading: false, type: 'success', msg: 'Message sent successfully!' });
                setFormData({ firstName: '', email: '', phone: '', subject: '', message: '' });
            } else {
                setStatus({ loading: false, type: 'error', msg: result.message || 'Failed to send.' });
            }
        } catch (error) {
            console.error("Error:", error);
            setStatus({ loading: false, type: 'error', msg: "Error sending message. Check connection." });
        }
    };

    return (
        <div>
            <main style={{ marginTop: "100px" }}>
                {/* Breadcrumb */}
                <div className="it-breadcrumb-area fix z-index-1" data-background="assets/img/shape/breadcrumb-1-bg.png">
                    <img className="it-breadcrumb-shape-1" src="assets/img/shape/breadcrumb-1-1.png" alt="" />
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xxl-5 col-xl-6 col-lg-6 col-md-6">
                                <div className="it-breadcrumb-content z-index-1">
                                    <div className="it-breadcrumb-title-box">
                                        <h3 className="it-breadcrumb-title">Contact Us</h3>
                                    </div>
                                    <div className="it-breadcrumb-list-wrap">
                                        <div className="it-breadcrumb-list">
                                            <span><Link to="/">Home</Link></span>
                                            <span className="dvdr">/</span>
                                            <i>Contact Us</i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-7 col-xl-6 col-lg-6 col-md-6">
                                <div className="it-breadcrumb-thumb z-index-1 text-end">
                                    <img src="assets/img/breadcrumb/contact.jpg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Form Area */}
                <div className="it-contact-3-area it-contact-3-style-2 pt-130 pb-130">
                    <div className="container">
                        <div className="row">
                            {/* Left Side: Icons instead of SVGs */}
                            <div className="col-lg-6 order-1 order-lg-0">
                                <div className="it-contact-3-left mt-10">
                                    <h5 className="it-details-title">I will Answer all Your <br />Questions</h5>
                                    <p className="mb-20">Lorem Ipsum is simply dummy text.</p>
                                    
                                    <div className="it-contact-list mt-25 mb-40">
                                        <span>Contact Info</span>
                                        <ul>
                                            <li>
                                                <span className="icon-box"><FaMapMarkerAlt size={20} color="#1F2432"/></span>
                                                <a href="#">610 E 20th St, New York, NY 10009, USA</a>
                                            </li>
                                            <li>
                                                <span className="icon-box"><FaPhoneAlt size={18} color="#1F2432"/></span>
                                                <a href="tel:+13059023242">+1 (305) 902-3242</a>
                                            </li>
                                            <li>
                                                <span className="icon-box"><FaEnvelope size={18} color="#1F2432"/></span>
                                                <a href="mailto:info@quickclasstakers.com">info@quickclasstakers.com</a>
                                            </li>
                                        </ul>
                                    </div>

                                    <span>Social Media</span>
                                    <div className="it-contact-social">
                                        <a href="#"><FaFacebookF /></a>
                                        <a href="#"><FaTwitter /></a>
                                        <a href="#"><FaLinkedinIn /></a>
                                        <a href="#"><FaYoutube /></a>
                                    </div>
                                </div>
                            </div>

                            {/* Right Side: Form */}
                            <div className="col-lg-6 order-0 order-lg-1">
                                <div className="it-contact-3-right">
                                    <div className="it-contact-3-form-box">
                                        <h4 className="it-section-title">Submit Your Query</h4>
                                        {status.msg && (
                                            <div className={`alert ${status.type === 'success' ? 'alert-success' : 'alert-danger'} mb-20`}>
                                                {status.msg}
                                            </div>
                                        )}
                                        <form onSubmit={handleSubmit}>
                                            <div className="it-signup-input-wrap">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="it-signup-input mb-40">
                                                            <label>First Name</label>
                                                            <input type="text" name="firstName" placeholder="Name" value={formData.firstName} onChange={handleChange} required />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="it-signup-input mb-40">
                                                            <label>Email</label>
                                                            <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="it-signup-input mb-40">
                                                            <label>Phone</label>
                                                            <input type="text" name="phone" placeholder="Phone" value={formData.phone} onChange={handleChange} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="it-signup-input mb-40">
                                                            <label>Subject</label>
                                                            <input type="text" name="subject" placeholder="Subject" value={formData.subject} onChange={handleChange} required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="it-signup-input mb-40">
                                                        <label>Message</label>
                                                        <textarea name="message" placeholder="Message" value={formData.message} onChange={handleChange} required></textarea>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="it-signup-input mb-40">
                                                        <button type="submit" className="it-btn-yellow theme-bg" disabled={status.loading}>
                                                            <span>
                                                                <span className="text-1">{status.loading ? 'Sending...' : 'Send Message'}</span>
                                                                <span className="text-2">{status.loading ? 'Sending...' : 'Send Message'}</span>
                                                            </span>
                                                            <i><FaPaperPlane /></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default ContactComp;